import { Theme, setTheme } from "themes/helpers";

import { useMessenger } from "./use-messenger";

export const useIframeTheme = (): void => {
  useMessenger<{ type: "theme:change"; payload: { theme: Theme } }, never>(message => {
    if (message.type === "theme:change") {
      setTheme(message.payload.theme);
    }
  });
};
